"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.keys");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.split");

var _delivery = require("@/api/delivery");

var _driverInfo = require("@/api/cms/driverInfo");

var _send = require("@/api/cms/send");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _DeliveryPeisong = _interopRequireDefault(require("./components/DeliveryPeisong"));

var _DeliveryKuaidi = _interopRequireDefault(require("./components/DeliveryKuaidi"));

var _DeliveryShansong = _interopRequireDefault(require("./components/DeliveryShansong"));

var _DeliveryWuliu = _interopRequireDefault(require("./components/DeliveryWuliu"));

var _DeliveryWuliuDian = _interopRequireDefault(require("./components/DeliveryWuliuDian"));

var _DeliveryZiti = _interopRequireDefault(require("./components/DeliveryZiti"));

var _CustomerInfo = _interopRequireDefault(require("./components/CustomerInfo"));

var _OrderInfo = _interopRequireDefault(require("./components/OrderInfo"));

var _DeliveryActions = _interopRequireDefault(require("./components/DeliveryActions"));

var _AddressSelector = _interopRequireDefault(require("./components/AddressSelector"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'DeliveryCreate',
  components: {
    CommonUpload: _commonUpload.default,
    AddressSelector: _AddressSelector.default,
    DeliveryPeisong: _DeliveryPeisong.default,
    DeliveryKuaidi: _DeliveryKuaidi.default,
    DeliveryShansong: _DeliveryShansong.default,
    DeliveryWuliu: _DeliveryWuliu.default,
    DeliveryWuliuDian: _DeliveryWuliuDian.default,
    DeliveryZiti: _DeliveryZiti.default,
    CustomerInfo: _CustomerInfo.default,
    OrderInfo: _OrderInfo.default,
    DeliveryActions: _DeliveryActions.default
  },
  dicts: ['order_display_fields', 'delivery_install_time_slot'],
  computed: {
    isInstruction: function isInstruction() {
      return this.$route.query.instruction === '1';
    },
    canOperate: function canOperate() {
      return this.sendStatus != null && (this.sendStatus >= 0 && this.sendStatus <= 60 || this.sendStatus === -1 || this.sendStatus >= 1010 && this.sendStatus <= 1050);
    },
    prevStatus: function prevStatus() {
      var levels = [0, 10, 20, 30, 40, 50, 60];
      var idx = levels.indexOf(this.sendStatus);
      if (idx > 0) return levels[idx - 1]; // 预约异常退回到待预约

      if (this.sendStatus === -1) return 10; // 非配送状态

      var nonDeliveryLevels = [1010, 1020, 1030, 1040, 1050];
      var idx2 = nonDeliveryLevels.indexOf(this.sendStatus);
      if (idx2 > 0) return nonDeliveryLevels[idx2 - 1];
      if (idx2 === 0) return 0;
      return 0;
    },
    amapApi: function amapApi() {
      return this.$store.state.api.amapApi;
    },
    amapSecurityJsCode: function amapSecurityJsCode() {
      return this.$store.state.api.amapSecurityJsCode;
    },
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.6;
    },
    checkedItems: function checkedItems() {
      return this.contractList;
    },
    accountingTotalPackages: function accountingTotalPackages() {
      return this.contractList.reduce(function (sum, s) {
        return sum + (parseInt(s.packages) || 0);
      }, 0);
    },
    accountingTotalInPackages: function accountingTotalInPackages() {
      return this.contractList.reduce(function (sum, s) {
        return sum + (parseInt(s.inPackages) || 0);
      }, 0);
    },
    accountingTotalArea: function accountingTotalArea() {
      return this.contractList.reduce(function (sum, s) {
        return sum + (parseFloat(s.area) || 0);
      }, 0);
    },
    accountingTotalVol: function accountingTotalVol() {
      return this.contractList.reduce(function (sum, s) {
        return sum + (parseFloat(s.vol) || 0);
      }, 0);
    } // rules 使用 data 而非 computed，因为 $refs 在 Vue 2 中非响应式

  },
  data: function data() {
    return {
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      editId: null,
      detailId: null,
      sendTaskId: null,
      isEdit: false,
      sendStatus: null,
      deliveryLog: null,
      initiator: '',
      initiateTime: '',
      tableLoading: false,
      tableHeader: [],
      contractList: [],
      rawSolutionIds: [],
      commissionErrors: {},
      customerInfo: {
        contactPerson: '',
        contactNumber: '',
        contactAddress: '',
        coordinate: ''
      },
      isSubmitting: false,
      attachmentList: [],
      addressSelectVisible: false,
      searchForm: {
        productionOrder: '',
        name: '',
        date: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allDriverList: [],
      refreshing: false,
      rules: {
        deliveryType: [{
          required: true,
          message: '请选择发货方式',
          trigger: 'change'
        }]
      },
      form: {
        deliveryNo: '',
        deliveryType: '配送(到家)',
        receiver: '',
        phone: '',
        address: '',
        remark: '',
        expressDate: '',
        expressTime: '',
        expressCompany: '',
        paymentMethod: '',
        warehouseLocation: '',
        deliveryPerson: '',
        expressRemark: '',
        pickupDate: '',
        pickupTime: ['', ''],
        loadingOrder: 1,
        licensePlate: '',
        driverName: '',
        driverPhone: '',
        pickupWarehouseLocation: '',
        pickupDeliveryPerson: '',
        pickupRemark: '',
        pickupAttachment: '',
        logisticsDate: '',
        logisticsTime: '',
        logisticsCompany: '',
        logisticsWarehouseLocation: '',
        logisticsDeliveryPerson: '',
        logisticsRemark: '',
        logisticsAttachment: '',
        logisticsTrackingNo: '',
        logisticsProgress: '',
        logisticsOrderPhoto: '',
        logisticsCollectionPhoto: '',
        deliveryChecklist: '',
        loadingCompletePhoto: '',
        hasLargeFurniture: '',
        deliveryVehicle: [],
        deliveryDriver: [],
        enterType: '',
        enterRemark: '',
        reserveImage: '',
        reserveTime: '',
        sendDate: '',
        doorTime: ['', ''],
        logisticsPointName: '',
        deliveryPersons: [],
        deliveryVehiclePlates: [],
        receivePerson: '',
        receivePhone: '',
        receiveAddress: '',
        coordinate: '',
        csAuditOpinion: '',
        phoneReserveTime: '',
        reserveTimeliness: '',
        expressNo: '',
        expressReceiveTime: '',
        expressPhoto: '',
        expressSendNote: '',
        expressAttachment: '',
        expressDeliveryPerson: '',
        expressDeliveryTime: '',
        expressCollectTime: '',
        expressOrderPhoto: '',
        expressTrackingNo: '',
        expressCollectionPhoto: '',
        expressProgress: '',
        expressSendDate: '',
        expressSendTime: '',
        expressSendRemark: '',
        expressSendAttachment: '',
        expressSendDeliveryPerson: '',
        expressSendDeliveryTime: '',
        expressSendCollectTime: '',
        expressSendCollectionPhoto: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$on('dictReady', function () {
      _this.initTableHeader();
    });
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.path === '/cms/delivery/create') {
        if (to.query.editId) {
          this.editId = to.query.editId;
          this.isEdit = true;
          this.initEditMode();
        } else {
          this.isEdit = false;
          this.detailId = null;
          this.sendTaskId = null;
          this.resetForm();
          this.resetDeliveryFields(); // 退回上一级/查看详情时不需要更新发货单号，仅新建时才生成

          var hasCachedDetail = sessionStorage.getItem('delivery_contractList');

          if (!hasCachedDetail) {
            this.generateDeliveryNo();
          }

          this.loadOrderData();
        }
      }
    },
    'form.deliveryType': function formDeliveryType(val) {
      var _this2 = this;

      // 切换前先清除当前校验，避免切换后旧提示残留
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }

      this.$nextTick(function () {
        return _this2.updateRules();
      });
      this.form.receivePerson = this.customerInfo.contactPerson || '';
      this.form.receivePhone = this.customerInfo.contactNumber || '';
      this.form.receiveAddress = this.customerInfo.contactAddress || '';
      this.form.coordinate = this.customerInfo.coordinate || '';
    }
  },
  activated: function activated() {
    // 浏览器刷新时 mounted 已加载全部数据，跳过重复请求
    if (this._firstActivated) {
      this._firstActivated = false;
      return;
    }

    if (this.form.deliveryType === '配送(到家)' || this.form.deliveryType === '配送(到物流点)') {
      this.loadAllDriverList();
    }

    if (!this.isEdit && !this.form.deliveryNo) {
      this.generateDeliveryNo();
    }

    if (this.isEdit) {
      this.refreshStatus();
    }

    this.loadAuditLog();
  },
  mounted: function mounted() {
    var _this3 = this;

    this._firstActivated = true;
    this.editId = this.$route.query.editId || null;
    this.isEdit = !!this.editId; // 配送模式才需要司机列表，编辑模式下在 initEditMode 获知发货方式后按需加载

    if (!this.isEdit) {
      this.loadAllDriverList();
    }

    this.initTableHeader();
    this.$nextTick(function () {
      return _this3.updateRules();
    });

    if (this.isEdit) {
      this.initEditMode();
      return;
    } // 退回上一级/查看详情时不需要更新发货单号，仅新建时才生成


    var hasCachedDetail = sessionStorage.getItem('delivery_contractList');

    if (!hasCachedDetail) {
      this.generateDeliveryNo();
    }

    this.loadOrderData();
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    parseSendPerson: function parseSendPerson(sendPerson) {
      if (!sendPerson) return [];

      try {
        var parsed = JSON.parse(sendPerson);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_unused) {
        return sendPerson.split(',').filter(Boolean).map(function (name) {
          return {
            userId: '',
            userName: name
          };
        });
      }
    },
    updateRules: function updateRules() {
      var common = {
        deliveryType: [{
          required: true,
          message: '请选择发货方式',
          trigger: 'change'
        }]
      };
      var refName = this.getRefByType();

      if (refName && this.$refs[refName]) {
        var childRules = this.$refs[refName].getRules();
        this.rules = _objectSpread(_objectSpread({}, common), childRules);
      } else {
        this.rules = _objectSpread({}, common);
      }
    },
    getRefByType: function getRefByType() {
      var map = {
        '配送(到家)': 'deliveryPeisong',
        '配送(到物流点)': 'deliveryWuliuDian',
        '快递': 'deliveryKuaidi',
        '自提': 'deliveryZiti',
        '物流': 'deliveryWuliu',
        '闪送': 'deliveryShansong'
      };
      return map[this.form.deliveryType] || null;
    },
    getChildComponent: function getChildComponent() {
      var refName = this.getRefByType();
      return refName ? this.$refs[refName] : null;
    },
    parseMaterialItem: function parseMaterialItem(item) {
      var material = {};

      if (item.materialData) {
        try {
          material = JSON.parse(item.materialData);
        } catch (_unused2) {}
      }

      return _objectSpread(_objectSpread({}, item), {}, {
        contractNo: material.contractNo || item.contractNumber || '',
        productionOrder: material.productionOrder || '',
        solutionName: item.orderName || '',
        packages: material.totalPackage != null ? material.totalPackage : item.packages,
        inPackages: material.inNum != null ? material.inNum : item.inPackages,
        area: material.area != null ? material.area : item.area,
        vol: material.volume != null ? material.volume : item.vol,
        isAll: material.isAll || item.isAll || '',
        inTime: material.inTime || item.inTime || '',
        stoneMaterial: material.stoneMaterial || '',
        stoneColor: material.stoneColor || '',
        stoneLength: material.stoneMeter != null ? material.stoneMeter : item.stoneMeter || '',
        deliveryCommission: item.deliveryCommission,
        bigHomeInstallCommission: item.bigHomeInstallCommission,
        floorCount: item.floorCount,
        floorCommission: item.floorCommission,
        otherCommission: item.otherCommission,
        accountingRemark: item.accountingRemark
      });
    },
    loadAllDriverList: function loadAllDriverList() {
      var _this4 = this;

      return (0, _driverInfo.getDriverInfoList)({
        page: 0,
        size: 9999
      }).then(function (res) {
        if (res.code === 200 && res.data && res.data.content) {
          _this4.allDriverList = res.data.content;
        }
      }).catch(function (err) {
        console.error('加载全部司机列表失败:', err);
      });
    },
    reloadContractData: function reloadContractData() {
      var _this5 = this;

      var sendNumber = this.form.deliveryNo;
      if (!sendNumber) return;
      (0, _send.getSendList)({
        sendNumber: sendNumber,
        page: 0,
        size: 1
      }).then(function (res) {
        if (res.code === 200 && res.data && res.data.content && res.data.content.length > 0) {
          _this5.sendStatus = res.data.content[0].status;
        }
      });
      var sendId = this.editId || this.detailId;

      if (sendId) {
        (0, _send.getSendOrdersBySendId)(sendId).then(function (sendOrderRes) {
          if (sendOrderRes.code === 200 && sendOrderRes.data && sendOrderRes.data.length > 0) {
            _this5.contractList = sendOrderRes.data.map(function (c) {
              return _this5.parseMaterialItem(_objectSpread(_objectSpread({}, c), {}, {
                contractId: c.contractId || c.orderId || c.id || '',
                contractNumber: c.contractNumber || '',
                custName: c.custName || '',
                custMobile: c.custMobile || '',
                custAddress: c.custAddress || '',
                status: c.status != null ? c.status : ''
              }));
            });
            _this5.total = _this5.contractList.length;
          }
        }).catch(function () {});
      }
    },
    refreshStatus: function refreshStatus() {
      var _this6 = this;

      if (this._refreshingStatus) return;
      this._refreshingStatus = true;
      var sendNumber = this.form.deliveryNo;

      if (!sendNumber) {
        this._refreshingStatus = false;
        return;
      }

      (0, _send.getSendList)({
        sendNumber: sendNumber,
        page: 0,
        size: 1
      }).then(function (res) {
        if (res.code === 200 && res.data && res.data.content && res.data.content.length > 0) {
          _this6.sendStatus = res.data.content[0].status;
        }
      }).catch(function () {}).finally(function () {
        _this6._refreshingStatus = false;
      });
    },
    openAddressSelector: function openAddressSelector() {
      this.addressSelectVisible = true;
    },
    onAddressSelect: function onAddressSelect(_ref) {
      var receivePerson = _ref.receivePerson,
          receivePhone = _ref.receivePhone,
          receiveAddress = _ref.receiveAddress,
          custAddress = _ref.custAddress;
      this.form.receivePerson = receivePerson;
      this.form.receivePhone = receivePhone;
      this.form.receiveAddress = receiveAddress;
      this.form.custAddress = custAddress;
    },
    onPeisongAttachmentChange: function onPeisongAttachmentChange(filePaths) {
      this.attachmentList = filePaths;
    },
    fillFormFromSave: function fillFormFromSave(saveData) {
      // saveData 结构应与 form 字段对应
      if (!saveData) return; // 发起信息

      if (saveData.deliveryNo) this.form.deliveryNo = saveData.deliveryNo;
      if (saveData.initiator) this.initiator = saveData.initiator;
      if (saveData.initiateTime) this.initiateTime = saveData.initiateTime;
      if (saveData.deliveryType) this.form.deliveryType = saveData.deliveryType;
      if (saveData.receivePerson) this.form.receivePerson = saveData.receivePerson;
      if (saveData.receivePhone) this.form.receivePhone = saveData.receivePhone;
      if (saveData.receiveAddress) this.form.receiveAddress = saveData.receiveAddress;
      if (saveData.coordinate) this.form.coordinate = saveData.coordinate; // 恢复提成信息（通过订单号 productionOrder 关联）

      this.restoreCommissionFromCache(); // 委托子组件填充类型特有字段

      var child = this.getChildComponent();

      if (child) {
        this.$nextTick(function () {
          return child.fillFromCache(saveData);
        });
      }
    },
    // 从 sessionStorage 缓存中恢复提成信息
    restoreCommissionFromCache: function restoreCommissionFromCache() {
      try {
        var cacheStr = sessionStorage.getItem('delivery_contractList');
        if (!cacheStr) return;
        var cache = JSON.parse(cacheStr);
        var saveData = typeof cache.saveData === 'string' ? JSON.parse(cache.saveData) : cache.saveData;
        if (!saveData || !saveData.commissionList || !Array.isArray(saveData.commissionList)) return;
        var commissionMap = {};
        saveData.commissionList.forEach(function (c) {
          if (c.productionOrder) {
            commissionMap[c.productionOrder] = c;
          }
        });
        this.contractList.forEach(function (c) {
          var saved = commissionMap[c.productionOrder];

          if (saved) {
            if (saved.deliveryCommission != null) c.deliveryCommission = saved.deliveryCommission;
            if (saved.bigHomeInstallCommission != null) c.bigHomeInstallCommission = saved.bigHomeInstallCommission;
            if (saved.floorCount != null) c.floorCount = saved.floorCount;
            if (saved.floorCommission != null) c.floorCommission = saved.floorCommission;
            if (saved.otherCommission != null) c.otherCommission = saved.otherCommission;
            if (saved.accountingRemark != null) c.accountingRemark = saved.accountingRemark;
          }
        });
      } catch (_unused3) {}
    },
    initTableHeader: function initTableHeader() {
      if (!this.dict || !this.dict.order_display_fields || this.dict.order_display_fields.length === 0) {
        return;
      }

      var fields = this.dict.order_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      this.tableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      this.loadHeaderConfig();
    },
    loadHeaderConfig: function loadHeaderConfig() {
      var _this7 = this;

      if (!this.tableHeader || this.tableHeader.length === 0) return;
      var savedConfig = localStorage.getItem('orderHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this7.tableHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }
          });
          this.tableHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
        } catch (e) {
          console.error('加载表头配置失败:', e);
        }
      }
    },
    generateDeliveryNo: function generateDeliveryNo() {
      var _this8 = this;

      (0, _delivery.getSendNumber)().then(function (res) {
        if (res && res.data && !_this8.form.deliveryNo) {
          _this8.form.deliveryNo = res.data;
        } else if (res && res.data && _this8.form.deliveryNo) {// 已有发货单号（如从缓存恢复），无需覆盖
        } else {
          _this8.$message.warning('获取发货单号异常，请刷新页面重试');
        }
      }).catch(function (err) {
        console.error('获取发货单号失败:', err);

        _this8.$message.error('获取发货单号失败，请检查网络或联系管理员');
      });
    },
    initEditMode: function () {
      var _initEditMode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this9 = this;

        var response, row;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isEdit = true;
                this.tableLoading = true;
                _context.prev = 2;
                _context.next = 5;
                return (0, _send.getSendList)({
                  id: this.editId,
                  page: 0,
                  size: 1
                });

              case 5:
                response = _context.sent;

                if (!(response.code !== 200 || !response.data || !response.data.content || response.data.content.length === 0)) {
                  _context.next = 10;
                  break;
                }

                this.$message.error('未找到查看数据');
                this.$router.push('/cms/delivery');
                return _context.abrupt("return");

              case 10:
                row = response.data.content[0];
                this.detailId = row.id || this.editId; // ========== 2. 填充表单基础字段 ==========

                this.sendStatus = row.status;
                this.initiator = row.createBy || '';
                this.initiateTime = row.createTime || '';
                this.form.deliveryNo = row.sendNumber || '';
                this.form.deliveryType = row.sendWay || '配送(到家)';

                if (this.form.deliveryType === '配送(到家)' || this.form.deliveryType === '配送(到物流点)') {
                  this.loadAllDriverList();
                }

                this.form.sendDate = row.sendDate ? row.sendDate.split(' ')[0] : '';
                this.form.doorTime = row.sendTime ? row.sendTime.split('-') : ['', ''];
                this.form.deliveryPersons = this.parseSendPerson(row.sendPerson);
                this.form.deliveryVehiclePlates = row.carNumber ? row.carNumber.split(',').filter(Boolean) : [];
                this.form.receivePerson = row.receivePerson || '';
                this.form.receivePhone = row.receivePhone || '';
                this.form.receiveAddress = row.receiveAddress || '';
                this.form.coordinate = row.coordinateX && row.coordinateY ? "".concat(row.coordinateX, ", ").concat(row.coordinateY) : row.positioning || ''; // 从 sessionStorage 恢复客户信息

                this.restoreCustomerInfoFromCache(); // ========== 3. 加载订单列表 ==========

                _context.next = 29;
                return this.loadContractListForEdit(row);

              case 29:
                // ========== 4. 恢复提成信息 ==========
                this.restoreCommissionFromCache();
                this.total = this.contractList.length; // ========== 5. 填充剩余字段 ==========

                this.sendTaskId = row.sendTaskId || null;
                this.form.remark = row.remark || '';
                this.form.hasLargeFurniture = row.hasProduct || row.hasLargeFurniture || '';
                this.form.deliveryVehicle = row.carNumber ? row.carNumber.split(',').filter(Boolean) : [];
                this.form.deliveryDriver = this.parseSendPerson(row.sendPerson).map(function (p) {
                  return p.userId;
                }).filter(Boolean);
                this.form.enterType = row.enterType || '';
                this.form.enterRemark = row.enterRemark || '';
                this.form.reserveImage = row.reserveImage || '';
                this.form.reserveTime = row.reserveTime || '';

                if (row.attachment) {
                  try {
                    this.attachmentList = JSON.parse(row.attachment);

                    if (this.attachmentList.length > 0 && typeof this.attachmentList[0] === 'string') {
                      try {
                        this.attachmentList = this.attachmentList.map(function (s) {
                          return JSON.parse(s);
                        });
                      } catch (_unused4) {}
                    }
                  } catch (_unused5) {
                    this.attachmentList = [];
                  }
                } // ========== 6. 委托子组件 & 审核日志 ==========


                this.$nextTick(function () {
                  var child = _this9.getChildComponent();

                  if (child) child.fillFromEdit(row);
                });
                this.$nextTick(function () {
                  return _this9.loadAuditLog();
                });
                this.tableLoading = false;
                this.refreshing = false;
                _context.next = 53;
                break;

              case 47:
                _context.prev = 47;
                _context.t0 = _context["catch"](2);
                console.error('查看数据解析失败:', _context.t0);
                this.$message.error('获取查看数据失败');
                this.$router.push('/cms/delivery');
                this.refreshing = false;

              case 53:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 47]]);
      }));

      function initEditMode() {
        return _initEditMode.apply(this, arguments);
      }

      return initEditMode;
    }(),
    // 从 sessionStorage 恢复客户信息
    restoreCustomerInfoFromCache: function restoreCustomerInfoFromCache() {
      try {
        var cached = sessionStorage.getItem('delivery_contractList');
        if (!cached) return;
        var parsed = JSON.parse(cached);
        var customer = parsed && parsed.customer ? parsed.customer : null;

        if (customer && customer.contactPerson) {
          this.customerInfo = {
            contactPerson: customer.contactPerson || '',
            contactNumber: customer.contactNumber || '',
            contactAddress: customer.contactAddress || '',
            coordinate: customer.coordinate || ''
          };
        }
      } catch (_unused6) {}
    },
    // 将合约/订单数据映射为统一的列表项格式
    mapContractItem: function mapContractItem(contract, customer) {
      var material = {};

      if (contract.materialData) {
        try {
          material = JSON.parse(contract.materialData);
        } catch (_unused7) {}
      }

      return _objectSpread(_objectSpread({}, contract), {}, {
        contractNo: material.contractNo || contract.contractNumber || contract.contractNo || '',
        productionOrder: material.productionOrder || contract.productionOrder || '',
        solutionName: contract.orderName || contract.solutionName || '',
        packages: material.totalPackage != null ? material.totalPackage : contract.packages,
        inPackages: material.inNum != null ? material.inNum : contract.inPackages,
        area: material.area != null ? material.area : contract.area,
        vol: material.volume != null ? material.volume : contract.vol,
        isAll: material.isAll || contract.isAll || '',
        inTime: material.inTime || contract.inTime || '',
        stoneMaterial: material.stoneMaterial || '',
        stoneColor: material.stoneColor || '',
        stoneLength: material.stoneMeter != null ? material.stoneMeter : contract.stoneMeter || '',
        contractId: contract.contractId || contract.orderId || contract.id || '',
        contractNumber: contract.contractNumber || material.contractNo || contract.contractNo || '',
        custName: contract.custName || contract.contactPerson || customer && customer.contactPerson || '',
        custMobile: contract.custMobile || contract.contactNumber || customer && customer.contactNumber || '',
        custAddress: contract.custAddress || contract.contactAddress || customer && customer.contactAddress || '',
        status: contract.status != null ? contract.status : contract.contractStatusEnumeration || '',
        deliveryCommission: contract.deliveryCommission,
        bigHomeInstallCommission: contract.bigHomeInstallCommission,
        floorCount: contract.floorCount,
        floorCommission: contract.floorCommission,
        otherCommission: contract.otherCommission,
        accountingRemark: contract.accountingRemark
      });
    },
    // 加载编辑模式下的订单列表（多级降级策略）
    loadContractListForEdit: function () {
      var _loadContractListForEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var _this10 = this;

        var res, cachedContract, parsed, items, customer, _res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _send.getSendOrdersBySendId)(this.editId);

              case 3:
                res = _context2.sent;

                if (!(res.code === 200 && res.data && res.data.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                this.contractList = res.data.map(function (c) {
                  return _this10.mapContractItem(c, null);
                });
                return _context2.abrupt("return");

              case 7:
                _context2.next = 11;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

              case 11:
                // 策略2：从 sessionStorage 缓存恢复
                cachedContract = sessionStorage.getItem('delivery_contractList');

                if (!cachedContract) {
                  _context2.next = 37;
                  break;
                }

                _context2.prev = 13;
                parsed = JSON.parse(cachedContract);
                items = parsed && parsed.items ? parsed.items : Array.isArray(parsed) ? parsed : [];
                customer = parsed && parsed.customer ? parsed.customer : null;

                if (!(items.length > 0 && typeof items[0] === 'number')) {
                  _context2.next = 31;
                  break;
                }

                _context2.prev = 18;
                _context2.next = 21;
                return (0, _send.getOrderSolutionsByIds)(items);

              case 21:
                _res = _context2.sent;

                if (!(_res.code === 200 && _res.data)) {
                  _context2.next = 25;
                  break;
                }

                this.contractList = _res.data.map(function (c) {
                  return _this10.mapContractItem(c, customer);
                });
                return _context2.abrupt("return");

              case 25:
                _context2.next = 29;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t1 = _context2["catch"](18);

              case 29:
                _context2.next = 33;
                break;

              case 31:
                this.contractList = items.map(function (c) {
                  return _this10.mapContractItem(c, customer);
                });
                return _context2.abrupt("return");

              case 33:
                _context2.next = 37;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t2 = _context2["catch"](13);

              case 37:
                // 策略3：回退到 row.contractList
                this.contractList = (row.contractList || []).map(function (c) {
                  return _this10.mapContractItem(c, null);
                });

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9], [13, 35], [18, 27]]);
      }));

      function loadContractListForEdit(_x) {
        return _loadContractListForEdit.apply(this, arguments);
      }

      return loadContractListForEdit;
    }(),
    loadOrderData: function loadOrderData() {
      var _this11 = this;

      var cachedData = sessionStorage.getItem('delivery_contractList');

      if (cachedData) {
        try {
          var parsed = JSON.parse(cachedData);
          var saveData = null; // 统一缓存格式：{ items, saveData, customer }，兼容旧格式纯数组

          if (parsed && parsed.items) {
            saveData = parsed.saveData;
            parsed = parsed.items;
          } // 查看模式：有发货单号从 t_send_order 查询，否则从缓存获取


          if (this.isEdit) {
            (0, _send.getSendOrdersBySendId)(this.editId).then(function (sendOrderRes) {
              if (sendOrderRes.code === 200 && sendOrderRes.data && sendOrderRes.data.length > 0) {
                _this11.contractList = sendOrderRes.data.map(function (c) {
                  return _this11.parseMaterialItem(_objectSpread(_objectSpread({}, c), {}, {
                    contractId: c.contractId || c.orderId || c.id || '',
                    contractNumber: c.contractNumber || c.contractNo || '',
                    custName: c.custName || c.contactPerson || '',
                    custMobile: c.custMobile || c.contactNumber || '',
                    custAddress: c.custAddress || c.contactAddress || '',
                    status: c.status != null ? c.status : ''
                  }));
                });
              } else {
                var _items = Array.isArray(parsed) ? parsed : [];

                var customer = null;

                try {
                  var cache = JSON.parse(cachedData);
                  customer = cache && cache.customer ? cache.customer : null;
                } catch (_unused11) {}

                var _solutionIds = _items.length > 0 ? typeof _items[0] === 'number' ? _items : _items.map(function (i) {
                  return i.id;
                }) : [];

                if (_solutionIds.length > 0) {
                  (0, _send.getOrderSolutionsByIds)(_solutionIds).then(function (res) {
                    if (res.code === 200 && res.data) {
                      _this11.contractList = res.data.map(function (c) {
                        return _this11.parseMaterialItem(_objectSpread(_objectSpread({}, c), {}, {
                          contractId: c.contractId || c.id || '',
                          contractNumber: c.contractNumber || c.contractNo || '',
                          custName: c.custName || c.contactPerson || customer && customer.contactPerson || '',
                          custMobile: c.custMobile || c.contactNumber || customer && customer.contactNumber || '',
                          custAddress: c.custAddress || c.contactAddress || customer && customer.contactAddress || '',
                          status: c.status != null ? c.status : c.contractStatusEnumeration || ''
                        }));
                      });
                    }
                  }).catch(function () {
                    _this11.contractList = [];
                  });
                } else {
                  _this11.contractList = _items.map(function (c) {
                    return _objectSpread(_objectSpread({}, c), {}, {
                      contractId: c.contractId || c.id || '',
                      contractNumber: c.contractNumber || c.contractNo || '',
                      custName: c.custName || c.contactPerson || customer && customer.contactPerson || '',
                      custMobile: c.custMobile || c.contactNumber || customer && customer.contactNumber || '',
                      custAddress: c.custAddress || c.contactAddress || customer && customer.contactAddress || '',
                      status: c.status != null ? c.status : c.contractStatusEnumeration || '',
                      deliveryCommission: c.deliveryCommission,
                      bigHomeInstallCommission: c.bigHomeInstallCommission,
                      floorCount: c.floorCount,
                      floorCommission: c.floorCommission,
                      otherCommission: c.otherCommission,
                      accountingRemark: c.accountingRemark
                    });
                  });
                }
              }

              _this11.total = _this11.contractList.length;
              _this11.tableLoading = false;
            }).catch(function () {
              _this11.contractList = [];
              _this11.total = 0;
              _this11.tableLoading = false;
            });
            return;
          } // 非查看模式（新增）：从缓存设置订单列表


          var items = Array.isArray(parsed) ? parsed : [];
          var solutionIds = items.length > 0 ? typeof items[0] === 'number' ? items : items.map(function (i) {
            return i.id;
          }) : []; // 通过接口查询完整订单数据

          if (solutionIds.length > 0) {
            this.rawSolutionIds = solutionIds;
            (0, _send.getOrderSolutionsByIds)(solutionIds).then(function (res) {
              if (res.code === 200 && res.data) {
                _this11.contractList = res.data.map(function (c) {
                  return _this11.parseMaterialItem(c);
                }); // 从 delivery_contractList 缓存直接覆盖提成信息

                var commissionSaveData = typeof saveData === 'string' ? JSON.parse(saveData) : saveData;

                if (commissionSaveData && commissionSaveData.commissionList && Array.isArray(commissionSaveData.commissionList)) {
                  var commissionMap = {};
                  commissionSaveData.commissionList.forEach(function (c) {
                    if (c.productionOrder) commissionMap[c.productionOrder] = c;
                  });

                  _this11.contractList.forEach(function (c) {
                    var saved = commissionMap[c.productionOrder];

                    if (saved) {
                      c.deliveryCommission = saved.deliveryCommission;
                      c.bigHomeInstallCommission = saved.bigHomeInstallCommission;
                      c.floorCount = saved.floorCount;
                      c.floorCommission = saved.floorCommission;
                      c.otherCommission = saved.otherCommission;
                      c.accountingRemark = saved.accountingRemark;
                    }
                  });
                }

                _this11.total = _this11.contractList.length;
              }
            }).catch(function () {
              _this11.contractList = [];
              _this11.total = 0;
            });
          } else if (items.length > 0) {
            // items 为对象时，提取 ID 重新查询接口获取最新数据
            var ids = items.map(function (c) {
              return c.id || c.orderSolutionId;
            }).filter(Boolean);
            this.rawSolutionIds = ids.length > 0 ? ids : items;

            if (ids.length > 0) {
              // 记录旧数据中的 commission 值（用户可能已编辑）
              var oldCommissionMap = {};
              items.forEach(function (c) {
                var cid = c.id || c.orderSolutionId;

                if (cid != null) {
                  oldCommissionMap[cid] = {
                    deliveryCommission: c.deliveryCommission,
                    bigHomeInstallCommission: c.bigHomeInstallCommission,
                    floorCount: c.floorCount,
                    floorCommission: c.floorCommission,
                    otherCommission: c.otherCommission,
                    accountingRemark: c.accountingRemark
                  };
                }
              });
              (0, _send.getOrderSolutionsByIds)(ids).then(function (res) {
                if (res.code === 200 && res.data) {
                  _this11.contractList = res.data.map(function (c) {
                    var mapped = _this11.parseMaterialItem(c); // 合并用户已编辑的 commission 值


                    var cid = c.id || c.orderSolutionId;

                    if (cid != null && oldCommissionMap[cid]) {
                      mapped.deliveryCommission = oldCommissionMap[cid].deliveryCommission;
                      mapped.bigHomeInstallCommission = oldCommissionMap[cid].bigHomeInstallCommission;
                      mapped.floorCount = oldCommissionMap[cid].floorCount;
                      mapped.floorCommission = oldCommissionMap[cid].floorCommission;
                      mapped.otherCommission = oldCommissionMap[cid].otherCommission;
                      mapped.accountingRemark = oldCommissionMap[cid].accountingRemark;
                    }

                    return mapped;
                  });
                  _this11.total = _this11.contractList.length;
                }
              }).catch(function () {
                // 接口失败时回退到缓存数据
                _this11.contractList = items.map(function (c) {
                  return _objectSpread(_objectSpread({}, c), {}, {
                    deliveryCommission: c.deliveryCommission,
                    bigHomeInstallCommission: c.bigHomeInstallCommission,
                    floorCount: c.floorCount,
                    floorCommission: c.floorCommission,
                    otherCommission: c.otherCommission,
                    accountingRemark: c.accountingRemark
                  });
                });
                _this11.total = _this11.contractList.length;
              });
            } else {
              this.contractList = items.map(function (c) {
                return _objectSpread(_objectSpread({}, c), {}, {
                  deliveryCommission: c.deliveryCommission,
                  bigHomeInstallCommission: c.bigHomeInstallCommission,
                  floorCount: c.floorCount,
                  floorCommission: c.floorCommission,
                  otherCommission: c.otherCommission,
                  accountingRemark: c.accountingRemark
                });
              });
              this.total = this.contractList.length;
            }
          } else {
            this.contractList = [];
            this.total = 0;
          } // 客户数据预填（始终从缓存设置 customerInfo）


          var hasCustomerCache = false;

          try {
            var cache = JSON.parse(cachedData);

            if (cache && cache.customer && cache.customer.contactPerson) {
              this.customerInfo = {
                contactPerson: cache.customer.contactPerson || '',
                contactNumber: cache.customer.contactNumber || '',
                contactAddress: cache.customer.contactAddress || '',
                coordinate: cache.customer.coordinate || ''
              };
              hasCustomerCache = true;
            } // 发货详情模式：从缓存恢复发货单号、状态和 id


            if (cache && cache.sendInfo && cache.sendInfo.sendNumber) {
              this.form.deliveryNo = cache.sendInfo.sendNumber;
              this.sendStatus = cache.sendInfo.status != null ? cache.sendInfo.status : null;
              this.initiator = cache.sendInfo.createBy || '';
              this.initiateTime = cache.sendInfo.createTime || '';
              this.detailId = cache.sendInfo.id || null;
              this.sendTaskId = cache.sendInfo.sendTaskId || null; // 查询接口获取最新发货单数据

              (0, _send.getSendList)({
                sendNumber: cache.sendInfo.sendNumber,
                page: 0,
                size: 1
              }).then(function (res) {
                if (res.code === 200 && res.data && res.data.content && res.data.content.length > 0) {
                  var row = res.data.content[0];
                  _this11.initiator = row.createBy || _this11.initiator;
                  _this11.initiateTime = row.createTime || _this11.initiateTime;
                  _this11.form.deliveryType = row.sendWay || '配送(到家)';
                  _this11.form.sendDate = row.sendDate ? row.sendDate.split(' ')[0] : '';
                  _this11.form.doorTime = row.sendTime ? row.sendTime.split('-') : ['', ''];
                  _this11.form.receivePerson = row.receivePerson || '';
                  _this11.form.receivePhone = row.receivePhone || '';
                  _this11.form.receiveAddress = row.receiveAddress || '';

                  if (row.coordinateX && row.coordinateY) {
                    _this11.form.coordinate = "".concat(row.coordinateX, ", ").concat(row.coordinateY);
                  }

                  _this11.form.hasLargeFurniture = row.hasProduct || row.hasLargeFurniture || '';
                  _this11.form.enterType = row.enterType || '';
                  _this11.form.enterRemark = row.enterRemark || '';
                  _this11.form.reserveImage = row.reserveImage || '';
                  _this11.form.reserveTime = row.reserveTime || '';
                  _this11.form.remark = row.remark || '';
                  _this11.form.deliveryVehicle = row.carNumber ? row.carNumber.split(',').filter(Boolean) : [];
                  _this11.form.deliveryDriver = _this11.parseSendPerson(row.sendPerson).map(function (p) {
                    return p.userId;
                  }).filter(Boolean);

                  if (row.attachment) {
                    try {
                      _this11.attachmentList = JSON.parse(row.attachment);

                      if (_this11.attachmentList.length > 0 && typeof _this11.attachmentList[0] === 'string') {
                        try {
                          _this11.attachmentList = _this11.attachmentList.map(function (s) {
                            return JSON.parse(s);
                          });
                        } catch (_unused12) {}
                      }
                    } catch (_unused13) {
                      _this11.attachmentList = [];
                    }
                  } // 委托子组件填充类型特有字段


                  _this11.$nextTick(function () {
                    var child = _this11.getChildComponent();

                    if (child && child.fillFromSendInfo) {
                      child.fillFromSendInfo(row);
                    }
                  }); // 从接口响应更新合同列表（含核算字段）


                  if (row.contractList && row.contractList.length > 0) {
                    _this11.contractList = row.contractList.map(function (c) {
                      return _objectSpread(_objectSpread({}, c), {}, {
                        id: c.id || c.orderSolutionId,
                        deliveryCommission: c.deliveryCommission,
                        bigHomeInstallCommission: c.bigHomeInstallCommission,
                        floorCount: c.floorCount,
                        floorCommission: c.floorCommission,
                        otherCommission: c.otherCommission,
                        accountingRemark: c.accountingRemark
                      });
                    });
                    _this11.total = _this11.contractList.length;
                  }
                }
              }).catch(function (err) {
                console.error('查询发货单数据失败:', err);
              });
            }
          } catch (_unused14) {} // 暂存信息预填（会覆盖表单中的收件人信息）；已有发货单号时从接口获取，不再读缓存


          if (!this.form.deliveryNo && saveData) {
            try {
              var sd = typeof saveData === 'string' ? JSON.parse(saveData) : saveData;
              if (sd) this.fillFormFromSave(sd);
            } catch (_unused15) {}
          } else if (!this.form.deliveryNo) {
            // 无暂存时优先从发货单实际数据填充，其次从客户信息兜底
            try {
              var _cache = JSON.parse(cachedData);

              var si = _cache && _cache.sendInfo;

              if (si && (si.receivePerson || si.receiveAddress)) {
                this.form.receivePerson = si.receivePerson || '';
                this.form.receivePhone = si.receivePhone || '';
                this.form.receiveAddress = si.receiveAddress || '';

                if (si.coordinateX && si.coordinateY) {
                  this.form.coordinate = "".concat(si.coordinateX, ", ").concat(si.coordinateY);
                }
              } else if (hasCustomerCache) {
                this.form.receivePerson = _cache.customer.contactPerson || '';
                this.form.receivePhone = _cache.customer.contactNumber || '';
                this.form.receiveAddress = _cache.customer.contactAddress || '';
                this.form.coordinate = _cache.customer.coordinate || '';
                this.custAddress = _cache.customer.contactAddress || '';
              }
            } catch (_unused16) {}
          }

          var _hasSaveData = !!saveData;

          this._initializing = true;
          this.$nextTick(function () {
            _this11._initializing = false;

            if (!_this11.isEdit && !hasCustomerCache && !_hasSaveData) {
              _this11.updateReceiverInfo();
            } // 配送(到家)/配送(到物流点)模式兜底：若收货信息仍为空，从客户信息填充


            if ((_this11.form.deliveryType === '配送(到家)' || _this11.form.deliveryType === '配送(到物流点)') && !_this11.form.receivePerson && !_this11.form.receivePhone && !_this11.form.receiveAddress) {
              _this11.form.receivePerson = _this11.customerInfo.contactPerson || '';
              _this11.form.receivePhone = _this11.customerInfo.contactNumber || '';
              _this11.form.receiveAddress = _this11.customerInfo.contactAddress || '';
              _this11.form.coordinate = _this11.customerInfo.coordinate || '';
            }
          });
          this.tableLoading = false;
          this.$nextTick(function () {
            return _this11.loadAuditLog();
          });
          this.refreshing = false;
          return;
        } catch (e) {
          console.error('解析缓存数据失败:', e);
          this.tableLoading = false;
          this.refreshing = false;
        }
      }

      this.contractList = [];
      this.total = 0;
      this.tableLoading = false;
      this.loadAuditLog();
      this.refreshing = false;
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadOrderData();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.currentPage = current;
      this.loadOrderData();
    },
    updateReceiverInfo: function updateReceiverInfo() {
      if (this.checkedItems.length === 0) {
        this.form.receivePerson = '';
        this.form.receivePhone = '';
        this.form.receiveAddress = '';
        this.form.coordinate = '';
        this.custAddress = '';
        this.custCoordinate = '';
        return;
      }

      var firstItem = this.checkedItems[0];
      this.form.receivePerson = firstItem.custName || firstItem.contactPerson || '';
      this.form.receivePhone = firstItem.custMobile || firstItem.contactNumber || '';
      this.form.receiveAddress = firstItem.custAddress || firstItem.contactAddress || '';
      this.form.coordinate = firstItem.positioning || '';
      this.custAddress = firstItem.custAddress || firstItem.contactAddress || '';
      this.custCoordinate = firstItem.positioning || '';
    },
    buildSaveDataJson: function buildSaveDataJson() {
      var raw = {
        deliveryNo: this.form.deliveryNo,
        initiator: this.initiator,
        initiateTime: this.initiateTime,
        deliveryType: this.form.deliveryType,
        receivePerson: this.form.receivePerson,
        receivePhone: this.form.receivePhone,
        receiveAddress: this.form.receiveAddress,
        coordinate: this.form.coordinate
      }; // merge child's type-specific data

      var child = this.getChildComponent();

      if (child) {
        var childData = child.buildSaveData();
        Object.assign(raw, childData);
      } // 提成信息（暂存到 save），按订单号的条数来保存


      var commissionList = this.contractList.map(function (c) {
        return {
          productionOrder: c.productionOrder,
          deliveryCommission: c.deliveryCommission,
          bigHomeInstallCommission: c.bigHomeInstallCommission,
          floorCount: c.floorCount,
          floorCommission: c.floorCommission,
          otherCommission: c.otherCommission,
          accountingRemark: c.accountingRemark
        };
      });

      if (commissionList.length > 0) {
        raw.commissionList = commissionList;
      } // attachment from deliveryPeisong


      if (this.$refs.deliveryPeisong) {
        var attList = this.$refs.deliveryPeisong.getAttachmentList();

        if (attList && attList.length > 0) {
          raw.attachment = attList;
        }
      }

      var saveData = {};

      for (var _i = 0, _Object$keys = Object.keys(raw); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var val = raw[key];

        if (val !== null && val !== '' && !(Array.isArray(val) && val.length === 0)) {
          saveData[key] = val;
        }
      }

      return JSON.stringify(saveData);
    },
    handleCommissionChange: function handleCommissionChange(row, field) {
      var key = row.id || row.orderSolutionId;
      var val = row[field];

      if (val != null && val !== '') {
        var errors = _objectSpread({}, this.commissionErrors[key]);

        delete errors[field];

        if (Object.keys(errors).length === 0) {
          this.$delete(this.commissionErrors, key);
        } else {
          this.$set(this.commissionErrors, key, errors);
        }
      }
    },
    handleSave: function handleSave(status) {
      var _this12 = this;

      if (this.isSubmitting) return; // 暂存：单独调用 updateOrderSolutionSaveBatch 接口，不生成发货单

      if (status === -1) {
        this.handleDraft();
        return;
      } // 保存(status=1)与提交(status=10)均生成发货单，走统一校验


      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this12.checkedItems.length === 0) {
            _this12.$message.error('请至少选择一个订单方案');

            return;
          }

          var runSave = function runSave() {
            _this12.isSubmitting = true;

            _this12.doSave(status);
          };

          var confirmMsg = _this12.isEdit ? '确定要更新发货单吗？' : status === 1 ? '确定要保存发货单吗？' : '确定要提交发货单吗？';

          _this12.$confirm(confirmMsg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(runSave).catch(function () {});
        }
      });
    },
    handleDraft: function handleDraft() {
      var _this13 = this;

      if (this.checkedItems.length === 0) {
        this.$message.warning('未找到可关联的订单方案');
        return;
      }

      var saveDataStr = this.buildSaveDataJson();
      var saveDataObj = JSON.parse(saveDataStr);
      delete saveDataObj.deliveryNo;
      (0, _send.updateOrderSolutionSaveBatch)({
        saveData: JSON.stringify(saveDataObj),
        solutionIds: this.rawSolutionIds
      }).then(function (response) {
        if (response.code === 200) {
          // 更新 sessionStorage 缓存中的 saveData，以便编辑时恢复提成信息
          try {
            var cacheStr = sessionStorage.getItem('delivery_contractList');
            var cache = cacheStr ? JSON.parse(cacheStr) : {};
            cache.saveData = JSON.stringify(saveDataObj);
            sessionStorage.setItem('delivery_contractList', JSON.stringify(cache));
          } catch (_unused17) {}

          _this13.$message.success('信息已暂存');
        } else {
          _this13.$message.error('暂存失败');
        }
      }).catch(function () {
        _this13.$message.error('信息暂存失败，请重试');
      });
    },
    doSave: function doSave(status) {
      var _this14 = this;

      // 非配送发货方式提交时使用1010状态码
      if (status === 10 && this.form.deliveryType !== '配送(到家)' && this.form.deliveryType !== '配送(到物流点)') {
        status = 1010;
      }

      var solutionIds = this.rawSolutionIds; // 从缓存中按 productionOrder 分组，相同 productionOrder 的共享同一组 solutionIds

      var cacheItems = function () {
        try {
          var cache = JSON.parse(sessionStorage.getItem('delivery_contractList'));
          return cache && cache.items ? cache.items : [];
        } catch (_unused18) {
          return [];
        }
      }();

      var poGroups = {};
      cacheItems.forEach(function (item) {
        var key = item.productionOrder;
        if (!poGroups[key]) poGroups[key] = [];
        poGroups[key].push(item.id);
      });
      var submitData = {
        sendWay: this.form.deliveryType,
        solutionIds: solutionIds,
        sendOrderItems: this.checkedItems.map(function (s) {
          return {
            orderId: s.orderId,
            contractNumber: s.contractNumber || '',
            orderName: s.orderName || s.solutionName || '',
            materialData: function () {
              var base = s.materialData ? typeof s.materialData === 'string' ? JSON.parse(s.materialData) : _objectSpread({}, s.materialData) : {
                productionOrder: s.productionOrder || ''
              };
              base.solutionIds = poGroups[s.productionOrder];
              return JSON.stringify(base);
            }(),
            status: s.status,
            deliveryCommission: s.deliveryCommission != null ? s.deliveryCommission : null,
            bigHomeInstallCommission: s.bigHomeInstallCommission != null ? s.bigHomeInstallCommission : null,
            floorCount: s.floorCount != null ? s.floorCount : null,
            floorCommission: s.floorCommission != null ? s.floorCommission : null,
            otherCommission: s.otherCommission != null ? s.otherCommission : null,
            accountingRemark: s.accountingRemark != null ? s.accountingRemark : null
          };
        }),
        status: status
      };
      submitData.receivePerson = this.form.receivePerson;
      submitData.receiveAddress = this.form.receiveAddress;
      submitData.receivePhone = this.form.receivePhone;

      if (this.isEdit) {
        submitData.id = this.editId;
      }

      if (this.form.coordinate) {
        var coordStr = this.form.coordinate.replace(/[()]/g, '').trim();
        var coords = coordStr.split(',');
        submitData.coordinateX = coords[0] || '';
        submitData.coordinateY = coords[1] || '';
      } // 委托子组件填充类型特有字段


      var child = this.getChildComponent();

      if (child) {
        child.getSubmitDataPatch(submitData);
      } // 提交时构建暂存数据，提交后由后端更新 t_order_solution.save


      submitData.saveData = this.buildSaveDataJson();
      var msg = status !== 1 ? '提交数据' : '保存数据';
      console.log(msg + ':', submitData);
      var apiCall = (0, _delivery.sendDelivery)(submitData);
      apiCall.then(function (response) {
        _this14.isSubmitting = false;

        if (response.code === 200) {
          _this14.$message.success(status !== 1 ? _this14.isEdit ? '发货单更新成功' : '发货单创建成功' : _this14.isEdit ? '更新成功' : '保存成功'); // 新建发货单时，从返回结果中获取发货单ID


          if (response.data && response.data.id) {
            _this14.detailId = response.data.id;
          }

          sessionStorage.removeItem('delivery_contractList');

          _this14.$store.dispatch('tagsView/delView', _this14.$route).then(function () {
            _this14.$router.push('/cms/delivery');
          });
        } else {
          _this14.$message.error(response.msg || '操作失败，请重试');
        }
      }).catch(function (error) {
        _this14.isSubmitting = false;
        console.error('操作失败:', error);

        _this14.$message.error('操作失败，请重试');
      });
    },
    handleRefresh: function handleRefresh() {
      if (this.refreshing) return;
      this.refreshing = true;

      if (this.isEdit) {
        this.initEditMode();
      } else {
        this.loadOrderData();
      }
    },
    goBack: function goBack() {
      var _this15 = this;

      sessionStorage.removeItem('delivery_contractList');
      sessionStorage.setItem('delivery_keepState', 'true');
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this15.$router.push('/cms/delivery');
      });
    },
    handleAuditDone: function handleAuditDone() {
      this.loadAuditLog();
      this.refreshStatus();
    },
    loadAuditLog: function loadAuditLog() {
      var _this16 = this;

      var sendNumber = this.form.deliveryNo;
      if (!sendNumber) return; // 始终直接调用 API 获取日志（不依赖子组件去重机制）

      (0, _send.getSendTaskLog)({
        page: 0,
        size: 1000,
        sendNumber: sendNumber
      }).then(function (res) {
        var logs = res.code === 200 && res.data && res.data.content ? res.data.content : [];

        if (logs.length > 0) {
          var auditLog = logs.find(function (item) {
            return item.step === '1010' || item.step === '1011';
          });
          var deliverLog = logs.find(function (item) {
            return item.step === '1040' || item.step === '1050';
          });

          if (auditLog || deliverLog) {
            var mergedDeliverLog = deliverLog ? _objectSpread({}, deliverLog) : {};

            if (mergedDeliverLog.photo) {
              try {
                var photoData = JSON.parse(mergedDeliverLog.photo);
                mergedDeliverLog = _objectSpread(_objectSpread({}, mergedDeliverLog), photoData);
              } catch (_unused19) {}
            }

            var auditFields = auditLog ? {
              audit_step: auditLog.step,
              audit_createTime: auditLog.createTime,
              audit_createBy: auditLog.createBy,
              audit_createByName: auditLog.createByName,
              audit_remark: auditLog.remark
            } : {};
            _this16.deliveryLog = _objectSpread(_objectSpread({}, mergedDeliverLog), auditFields);
          }
        }
      }).catch(function () {}); // 同时触发配送子组件刷新日志显示

      var peisong = this.$refs.deliveryPeisong;
      var wuliudian = this.$refs.deliveryWuliuDian;
      if (peisong) peisong.loadLog();
      if (wuliudian) wuliudian.loadLog();
    },
    handleRevoked: function handleRevoked() {
      try {
        var cache = JSON.parse(sessionStorage.getItem('delivery_contractList'));

        if (cache && cache.sendInfo) {
          delete cache.sendInfo;
          sessionStorage.setItem('delivery_contractList', JSON.stringify(cache));
        }
      } catch (_unused20) {}

      this.editId = null;
      this.isEdit = false;
      this.detailId = null;
      this.sendTaskId = null;
      this.sendStatus = null;
      this.initiator = '';
      this.initiateTime = '';
      this.generateDeliveryNo(); // 撤销后从 sessionStorage 缓存恢复订单数据（后端已物理删除 t_send，不可再查后端）

      this.loadOrderData();
    },
    handleStepBack: function handleStepBack(targetStatus) {
      this.sendStatus = targetStatus;
      this.refreshStatus();

      if (this.$refs.deliveryPeisong) {
        this.$refs.deliveryPeisong.loadLog();
      }

      if (this.$refs.deliveryWuliuDian) {
        this.$refs.deliveryWuliuDian.loadLog();
      }
    },
    handleDeliverySubmit: function handleDeliverySubmit() {
      var _this17 = this;

      this.$confirm('确定提交发货信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this17.isSubmitting = true;
        var contractNumber = _this17.contractList && _this17.contractList.length > 0 ? _this17.contractList[0].contractNumber || _this17.contractList[0].contractNo || _this17.contractList[0].custContractNo || '' : '';

        var child = _this17.getChildComponent();

        var photoData = child && child.buildDeliverySubmitPhoto ? child.buildDeliverySubmitPhoto() : {};
        var photo = JSON.stringify(photoData).replace(/\//g, '');
        (0, _send.addSendTaskLog)({
          sendTaskId: _this17.sendTaskId,
          sendNumber: _this17.form.deliveryNo || '',
          contractNumber: contractNumber,
          step: '1040',
          photo: photo
        }).then(function () {
          _this17.$message.success('发货信息提交成功');

          _this17.$store.dispatch('tagsView/delView', _this17.$route).then(function () {
            _this17.$router.push('/cms/delivery');
          });
        }).catch(function (error) {
          console.error('发货信息提交失败:', error);

          _this17.$message.error('操作失败，请重试');
        }).finally(function () {
          _this17.isSubmitting = false;
        });
      }).catch(function () {});
    },
    resetDeliveryFields: function resetDeliveryFields() {
      this.customerInfo = {
        contactPerson: '',
        contactNumber: '',
        contactAddress: '',
        coordinate: ''
      };
      this.form.deliveryPersons = [];
      this.form.deliveryVehiclePlates = [];
      this.form.receivePerson = '';
      this.form.receivePhone = '';
      this.form.receiveAddress = '';
      this.form.coordinate = '';
      this.form.sendDate = '';
      this.form.doorTime = ['', ''];
      this.form.hasLargeFurniture = '';
      this.form.deliveryVehicle = [];
      this.form.deliveryDriver = [];
      this.form.enterType = '';
      this.form.enterRemark = '';
      this.form.reserveImage = '';
      this.form.reserveTime = '';
      this.attachmentList = [];
    },
    resetForm: function resetForm() {
      this.form = {
        deliveryNo: '',
        deliveryType: '配送(到家)',
        receiver: '',
        phone: '',
        address: '',
        remark: '',
        expressDate: '',
        expressTime: '',
        expressCompany: '',
        paymentMethod: '',
        warehouseLocation: '',
        deliveryPerson: '',
        expressRemark: '',
        pickupDate: '',
        pickupTime: ['', ''],
        loadingOrder: 1,
        licensePlate: '',
        driverName: '',
        driverPhone: '',
        pickupWarehouseLocation: '',
        pickupDeliveryPerson: '',
        pickupRemark: '',
        pickupAttachment: '',
        logisticsDate: '',
        logisticsTime: '',
        logisticsCompany: '',
        logisticsWarehouseLocation: '',
        logisticsDeliveryPerson: '',
        logisticsRemark: '',
        logisticsAttachment: '',
        hasLargeFurniture: '',
        deliveryVehicle: [],
        deliveryDriver: [],
        enterType: '',
        enterRemark: '',
        reserveImage: '',
        reserveTime: '',
        sendDate: '',
        doorTime: ['', ''],
        logisticsPointName: '',
        deliveryPersons: [],
        deliveryVehiclePlates: [],
        receivePerson: '',
        receivePhone: '',
        receiveAddress: '',
        coordinate: '',
        custAddress: '',
        custCoordinate: '',
        csAuditOpinion: '',
        phoneReserveTime: '',
        reserveTimeliness: '',
        expressNo: '',
        expressReceiveTime: '',
        expressPhoto: '',
        expressSendNote: '',
        expressAttachment: '',
        expressDeliveryPerson: '',
        expressDeliveryTime: '',
        expressCollectTime: '',
        expressOrderPhoto: '',
        expressTrackingNo: '',
        expressCollectionPhoto: '',
        expressProgress: '',
        expressSendDate: '',
        expressSendTime: '',
        expressSendRemark: '',
        expressSendAttachment: '',
        expressSendDeliveryPerson: '',
        expressSendDeliveryTime: '',
        expressSendCollectTime: '',
        expressSendCollectionPhoto: ''
      };
      this.attachmentList = [];
      this.sendStatus = null;
      this.initiator = '';
      this.initiateTime = '';
      this.generateDeliveryNo();
    }
  }
};
exports.default = _default;